<template>
  <div class="landscape-image">
    <collection-image :image="image"></collection-image>
  </div>
</template>

<script>
import CollectionImage from 'components/CollectionImage'
export default {
  name: 'LandscapeImage',
  props: ['imageUrl', 'imageAlt', 'text', 'imageTableHeader', 'imageTableText'],
  components: {
    CollectionImage
  },
  data () {
    return {
    }
  },
  computed: {
    image () {
      return {
        type: null,
        src: this.imageUrl,
        caption: this.text,
        alt: this.imageAlt,
        table: {
          header: this.imageTableHeader,
          text: this.imageTableText
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.landscape-image{
  figure{ // inner
    width:79.6875%;
    margin:0 auto;
    img{
      margin:$gutter auto;
      //max-height:80vh;
    }
  }
  @media (max-width:768px){
    figure{
      max-width:none;
      padding:0 $gutter;
      img{
        max-height:none;
      }
    }
  }
  @include on_mobile() {
    margin:$collectionMobile-blockMargin-ns 0;
    figure{
      width:auto;
      padding:0;
    }
    figcaption{
      padding:0 $gutter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Collection__Story__LandscapeImage.vue?9bd64fc0